<template>
  <div v-loading="loading">
    <el-tabs size="small" v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="基础设置" name="basic"></el-tab-pane>
      <el-tab-pane label="其它设置" name="index"></el-tab-pane>
    </el-tabs>

    <!--基础设置-->
    <Basic v-if="activeName == 'basic' && is_load" :settingData="settingData" :gradeList="gradeList"></Basic>
    <Index v-if="activeName == 'index'" :settingData="settingData"></Index>

  </div>
</template>
<script>
import SettingApi from '@/api/study/setting.js';
import Basic from './part/Basic.vue';
import Index from './part/Index.vue';
export default {
  components: {
    Basic,
    Index
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      form: {
        status: 0
      },
      activeName: 'basic',
      /*数据对象*/
      settingData:{},
      gradeList: [],
      is_load: false,
    };
  },
  created() {
    if (this.$route.query.type != null) {
      this.activeName = this.$route.query.type;
    }
    this.getData();
  },
  methods: {
    /*获取数据*/
    getData() {
      let self = this;
      SettingApi.getSetting({}, true)
        .then(res => {
          self.settingData = res.data;
          self.gradeList = res.data.gradeList;
          self.loading=false;

          // 默认
          let tabs = self.$db.getRouteField(self, 'tabs');
          if (tabs) self.activeName = tabs;

          self.$forceUpdate();
          self.is_load = true;
        })
        .catch(error => {});
    },
    /*切换*/
    handleClick(e) {
      this.activeName = e.name;
      this.$db.setRoute(this, {'tabs': e.name});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/setting/index.vue